import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class SendEmailService {

    constructor(private http: HttpClient) { }

    sendConfirmationEmail(sendEmailBody, url) {
        return this.http.post(url, {
            to_emails: sendEmailBody.to_emails,
            subject: sendEmailBody.subject,
            content: sendEmailBody.content,
        });
    }
}